<template>
  <div class="chord-dict">
    <h3>Chord Dict</h3>
    <table border="1">
      <thead>
      <tr>
        <th>#</th>
        <th>Type</th>
        <th>Intervals</th>
        <th>Shape</th>
        <!--        TODO: diatonic -->
        <th>Nat.</th>
        <th>Melo.</th>
        <th>Harm.</th>
        <th>Dim.</th>
        <th>WholT.</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="chord, i in chords" :key="i">
        <th>{{ i + 1 }}</th>
        <td>{{ chord.chordType }}</td>
        <td>{{ chord.intervalString }}</td>
        <td>
          <div>
          <span class="interval-state"
                v-for="state, i in chord.intervalStates"
                :key="i"
                :class="{
                  'on': state
                }"
          >_</span>
          </div>
        </td>
        <!--        <td>{{chord.diatonics.natural.length || ' '}}</td>-->
        <!--        <td>{{chord.diatonics.melodic.length || ' '}}</td>-->
        <!--        <td>{{chord.diatonics.harmonic.length || ' '}}</td>-->
        <!--        <td>{{chord.diatonics.diminished.length || ' '}}</td>-->
        <!--        <td>{{chord.diatonics.wholeTone.length || ' '}}</td>-->

        <td v-for="scale, scaleId in 'natural,melodic,harmonic,diminished,wholeTone'.split(',')"
            :key="scaleId"
        >
          <div><span class="interval-state"
                     v-for="i in 12" :key="i" :class="{ 'on': chord.diatonics[scale].indexOf(i - 1) > -1 }"
          >_</span></div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import PianoKeyboard from '@/components/PianoKeyboard'
// import CurrentChords from '@/components/CurrentChords'
// import { MIDIAgent } from '@/utils/MIDIAgent.js'
// import { lookupChords } from '@/utils/Chord'
import { CHORD_DATA, INTERVAL_SIZE } from '@/utils/musical_constants'
import { chordTypeToToneArray, encodeToneArrayToInt, matchToneArray } from '@/utils/Chord'

export default {
  name: 'ChordDict',
  setup () {
    return {
      CHORD_DATA: CHORD_DATA,
      chordTypeToToneArray: chordTypeToToneArray,
      encodeToneArrayToInt: encodeToneArrayToInt
    }
  },
  data () {
    return {
      chords: []
    }
  },
  created () {
    for (const intervalString of Object.keys(CHORD_DATA)) {
      const intervals = intervalString.split(',').map(x => INTERVAL_SIZE[x] % 12).sort()
      const intervalStates = new Array(12).fill(0).map((x, i) => intervals.indexOf(i) > -1 ? 1 : 0)
      const intervalToneArray = encodeToneArrayToInt(intervals)
      this.chords.push({
        chordType: CHORD_DATA[intervalString],
        intervalString: intervalString,
        intervals: intervals,
        intervalStates: intervalStates,
        intervalToneArray: intervalToneArray,
        diatonics: {
          natural: matchToneArray(intervalToneArray, 0b101010110101),
          harmonic: matchToneArray(intervalToneArray, 0b100110101101),
          melodic: matchToneArray(intervalToneArray, 0b101010101101),
          diminished: matchToneArray(intervalToneArray, 0b101101101101),
          wholeTone: matchToneArray(intervalToneArray, 0b010101010101)
        }
      })
    }
  }
}
</script>

<style scoped>
.interval-state {
  font-family: monospace;
}

.chord-dict {
  background-color: #f0f0f0;
}

tr:nth-child(2n) {
  background-color: #fafafa;
}

tr div span:nth-child(1),
tr div span:nth-child(3),
tr div span:nth-child(5),
tr div span:nth-child(6),
tr div span:nth-child(8),
tr div span:nth-child(10),
tr div span:nth-child(12) {
  /*background-color: #eee;*/
}

tr div span:nth-child(2),
tr div span:nth-child(4),
tr div span:nth-child(7),
tr div span:nth-child(9),
tr div span:nth-child(11) {
background: rgb(221,221,221);
background: linear-gradient(180deg, rgba(221,221,221,1) 0%, rgba(221,221,221,1) 57%, rgba(247,247,247,0) 58%, rgba(255,255,255,0) 100%);
}

.on {
  background: #222 !important;
}

table {
  width: 100%;
  border-collapse: collapse;
}
</style>
